<button type="button" (click)="onSearch()"></button>
<input #input type="search" [placeholder]="placeholder">
